<template>
    <div class="parallax-container" >
        <img :src="src" class="parallax-container__image" ref="block">
    </div>
</template>
<style lang="stylus">
    .parallax-container
        &__image
            width 100%
</style>
<script>
    import simpleParallax from 'simple-parallax-js';
    export default {
        props: ['src'],
        data() { 
            return {
                is_ie: document.documentMode || /Edge/.test(navigator.userAgent)
            };
        },
        mounted() {
            if (!this.is_ie) {
                let parallaxInstance = new simpleParallax(this.$refs.block);
                console.log(parallaxInstance);
            }
        },
    };
</script>